<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title" i18n>Captură imagine hartă</h5>
    </div>

    <div #editorHost class="modal-body">
        <div class="map-image-container">
            <img #mapImageElement class="map-image-preview" [src]="mapImgUrl" />
        </div>
    </div>

    <div class="modal-footer">
        <div *ngIf="loading" class="mr-auto">
            <i class="fa fa-circle-o-notch fa-spin" style="font-size:24px"></i>
        </div>
        <button type="button" class="btn btn-secondary" [hidden]="isEditorOpen" (click)="openEditor()" i18n>Editează</button>
        <button type="button" class="btn btn-primary" [hidden]="isEditorOpen" (click)="save()" i18n>Descarcă</button>
        <button type="button" class="btn" (click)="cancel()" i18n>Renunță</button>
    </div>
</div>
